import React, {useState, useEffect} from 'react';
import {pushEdapEvent} from '../../utils/edap';
import {addListener, removeAllListeners} from '../../utils/scroll';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import './arrow-mobile.svg';
import './arrow-desktop.svg';
import {selector} from '../../utils/wdio-selectors';

const ACTION_LOCATION = 'back-to-top';

let scrollHandler;
const scrollAnimation = (distance) => {
    if (window.pageYOffset === 0) {
        clearInterval(scrollHandler);
    }
    scrollBy(0, -distance);
};

const scrollToTop = () => {
    const ANIMATION_TIME = 600;
    const INTERVAL_TIME = 10;
    const MINIMUM_DISTANCE = 90;
    const distancePerInterval = Math.max(
        window.pageYOffset / (ANIMATION_TIME / INTERVAL_TIME),
        MINIMUM_DISTANCE
    );

    scrollHandler = setInterval(() => {
        scrollAnimation(distancePerInterval);
    }, INTERVAL_TIME);

    pushEdapEvent('cta.selected', {
        action_location: ACTION_LOCATION,
        event_category: 'back-to-top',
        event_action: 'button-clicked',
    });
};

const ScrollToTop = ({translation}) => {
    const [displayBackToTopButton, setDisplayBackToTopButton] = useState(false);

    useEffect(() => {
        const jumbotronHeight = document.querySelector('.jumbotron')
            .clientHeight;
        addListener(() =>
            setDisplayBackToTopButton(window.pageYOffset > jumbotronHeight)
        );

        return () => {
            if (displayBackToTopButton) removeAllListeners();
        };
    });

    const button = (
        <>
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'top',
                }}
                edapEvent={'content_module.presented'}
            />
            <button
                aria-label={translation}
                onClick={() => scrollToTop()}
                className="scroll-to-top btn btn-primary"
                data-wdio={selector.backToTop}
            >
                <span>{translation}</span>
            </button>
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'bottom',
                }}
                edapEvent={'content_module.presented'}
            />
        </>
    );

    return translation && displayBackToTopButton ? button : null;
};

export default ScrollToTop;
